import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormTextarea from "Common/Custom/FormTextarea";
import FormDatePicker from "Common/Custom/ReactFlatpickr";

const EditWakeUpCallForm = ({
  fields = {},
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  title = "Title Note Provide",
  SelectOptions = [],
}) => {
  return (
    <PageBody onSubmit={handleSubmit} headerchildren={
      <HeadingOne>Update {title}</HeadingOne>
    }>
      {fields.map((field) => {

        if (field.type === "select") {
          const options = SelectOptions.map((opt) => ({
            value: opt.customer_id,
            label: opt.first_name
          }));
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={options}
              error={errors[field.name]}
            />
          );
        }
        if (field.type == 'textarea') {
          return (
            <FormTextarea
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }
        if (field.type == 'date') {
          return (
            <FormDatePicker
                          key={field.name}
                          field={field}
                          value={values[field.name]}
                          handleChange={handleChange}
                          error={errors[field.name]}
                          mode="datetime"   // 👈 ADD THIS
                        />
          );
        }

        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label={`Update ${title}`}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditWakeUpCallForm;
